export default {
  c1: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/%E7%B9%81%E4%BD%93%402x%282%29.png',
  c2: '积分明细',
  c3: '积分说明',
  c4: '启用积分码',
  c5: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/%E6%9D%A1%E6%AC%BE%E5%8F%8A%E7%BB%86%E5%88%99-%E7%AE%80%E4%BD%93%402x.png',
  c6: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95-%E7%AE%80%E4%BD%93%402x.png',
  c7: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/%E6%88%91%E7%9A%84%E7%94%B5%E5%AD%90%E5%88%B8-%E7%AE%80%E4%BD%93%402x.png',
  c8: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%9B%B2%E7%9B%92%E4%B8%AD%E5%A5%96%E8%AE%B0%E5%BD%95%E9%A1%B5%20%E2%80%93%201_slices/mygarden%402x.png',
  c9: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E9%BB%9E%E6%88%91%402x%20%281%29.png',
  c10: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E7%8E%A9%E4%BB%BB%E5%8B%99%E8%B3%BA%E7%A9%8D%E5%88%86%402x%20%282%29.png',
  c11: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E6%B5%AE%E7%AA%97-%E7%B0%A1%E9%AB%94%402x.png',
  c12: '热门任务',
  c13: '赚取高额积分专区',
  c14: '查看更多',
  c15: '恭喜{Name}获得',
  c16: '下次开盲盒',
  c17: '恭喜! 你获得盲盒奖品',
  c18: '你可以在「积分明细」查看积分到帐情况',
  c19: '你可以在「我的电子券」查看电子券到帐情况',
  c20: '前往「积分明细」',
  c21: '前往「我的电子券」',
  c22: '前往「MyGarden」领取奖赏',
  c23: '你可以在「MyGarden」领取奖赏',
  c24: '多谢参与，明天再来',
  c25: '再开一个',
  c26: '知道了',
  c27: '你的手机或终端设备登入参加此活动的数量已超出限制',
  c28: '详情请参阅',
  c29: '《条款及细则》',
  c30: '活动已结束',
  c31: '同一天不能同时获取签到积分和盲盒积分啊，请明天再来吧！',
  c32: '分享中大奖喜悦给朋友啊!',
  c33: '分享喜悦',
  c34: '下次开盲盒',
  c35: 'MyLink幸运盲盒日日赏',
  c36: '每天奖赏可高达10,000 MyLink积分，更有机会得到MyGarden道具及电子优惠券! 马上去开盲盒拿惊喜啦!',
  c37: '分享',
  c38: '我今天抽到了',
  c39: '! 你也赶快去开盲盒拿惊喜啦!',
  c40: '前往\n「积分明细」',
  c41: '前往\n「我的电子券」',
  c41_1: '前往\n「商城」使用',
  c41_2: '前往\n「游戏乐园」',
  c41_3: '前往\n「保险页」使用',
  c42: '前往\n「MyGarden」领取奖品',
  c43: '推广生意的竞赛牌照号码：',
  c44: '条款及细则',
  c45: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/rule%202.png',
  c46: '参加本次活动前， 请先阅读并同意以上《条款及细则》',
  c47: '不同意',
  c48: '同意并参加',
  c49: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/%E6%B5%AE%E7%AA%97-%E7%B0%A1%E9%AB%94%402x.png',
  c50: 'MyLink幸运盲盒日日赏',
  c51: '每天奖赏可高达10,000 MyLink积分，更有机会得到MyGarden道具及电子优惠券! 马上去开盲盒拿惊喜啦!',
  c52: '同一天不能同时获取签到积分和盲盒积分啊，请明天再来吧！',
  c53: '查看更多任务',
  c54: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/points%40sc.gif',
  c55: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/luckyCard/luckyCardTitle_sc.png',
  year: '年',
  month: '月',
  c56: '取消',
  c57: '选择年月',
  c58: '完成',
  c59: '保存图片',
  c60: '分享好友',
  c61: '每日箴言',
  c62: '哎呀,',
  c63: '没开盲盒啊',
  c64: '图片已保存到本地相册',
  c65: '查看「每日箴言」',
  c66: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/luckyCard/luckyCardIcon_sc.png',
  c67: 'luckyCardImg_sc.png',
  c68: '游戏专区',
  d1: '开盲盒提醒说明',
  d2: '开启开盲盒提醒功能后，若本月开盲盒次数少于3天，系统将会于当月的8号、16号、24号发送开盲盒提醒通知，关闭功能则不提醒。',
  d3: '提醒抢券',
  d4: '宜',
  Rule: {
    c1: '「幸运盲盒」之条款及细则（「本条款及细则」）',
    c2: [
      '1.「幸运盲盒」（「活动」）由中国移动香港有限公司（「中移香港」）主办。',
      '2.活动于香港时间2025年11月4日开始至2026年2月3日23:59结束（「活动期」），时间以中移香港的服务器时间为准。'
    ],
    c3: '合资格人士',
    c4: [
      '3.参加者需要符合以下资格方为活动的合资格参加者（「合资格参加者」）：',
      '(a)可成功以有效香港电话号码注册并登入MyLink的人士，包括中移香港的现有储值卡客户、月费服务计划客户、家居宽带客户、企业客户（包括副卡和成员卡客户）及非中移香港用户；及',
      '(b)非根据第23段被列入活动黑名单的人士。',
      '若未能符合上述资格，相关参加及/或得奖资格将会被取消。'
    ],
    c5: '活动详情',
    c6: [
      '4.活动期内，合资格参加者可以以下方式参加活动：',
      '(a)从MyLink任务乐园直接点击盲盒即可参加活动。',
      '(b)合资格参加者每天可享一次点击盲盒机会，有机会得到MyLink积分 (「积分」)，积分数量为随机发放、有机会得到MyGarden减碳值或功能卡、及有机会得到通讯、餐饮或零售券等电子券 （统称为「奖品」）。',
      '(c)若合资格参加者当天没有用完每天最多一次的点击盲盒机会，未有使用或剩下的点击盲盒机会将于当天23:59撤销，并不能累积到下一天。',
      '(d)点击盲盒的奖品为随机发放，中移香港并不保证合资格参加者于活动期内可以获得第4b段所列的奖品。',
      '5.每个终端设备（如手机、平板计算机）只限一位合资格参加者使用同五个香港流动电话号码登记的MyLink账号参加活动，如合资格参加者以同一个终端设备登入多于五个以上的MyLink账号参加活动，中移香港有权取消相关MyLink账号参加活动以及获得积分的资格。'
    ],
    c7: 'MyLink积分使用及注意事项',
    c8: [
      '6.活动期内，合资格参加者如获得积分，所获得的积分会在3个工作天内自动存入其MyLink账户。积分余额显示在「个人头像–我的积分」页面。',
      '7.活动所获得的积分有效期取决于积分被存入用户的 MyLink 帐户之时间。（「积分有效期」）。',
      '8.如活动领取的积分与任何其他积分领取活动的条款细则存有差异，一律以MyLink账户中所显示的有效积分为准。',
      '9.合资格参加者应于积分有效期满前使用积分作兑换奖赏或购买指定产品/服务，逾期作废，并将不获补发或延长有效期。合资格参加者兑换及使用积分，须阅读并同意MyLink积分计划的条款及细则（https://mylink.komect.com/mylink/#/integral/rules?lang=tc）。',
      '10.合资格参加者透过活动获取积分后，不可退换或兑换现金，亦不能更换丶退款丶转赠或转让他人，不同合资格参加者的积分亦不可合并使用。当合资格参加者撤销其MyLink注册账户时，其MyLink账户内的积分将会自动注销及不获补发，中移香港亦不会作出任何补偿。'
    ],
    c9: 'MyGarden减碳值、功能卡使用及注意事项',
    c10: [
      '11.合资格参加者须前往MyLink 之MyGarden领取及使用活动所抽到的减碳值或功能卡待领取的减碳值有效期为合资格参加者每次领取减碳值的日期之翌日起计算的7日内到期，功能卡的有效期为合资格参加者获取功能卡的日期之当日起计算的90日内到期，逾期无效。合资格参加者领取及使用减碳值或功能卡，须阅读并同意MyGarden页面内的MyGarden使用条款及细则 (详情请浏览：https://cdn.mylinkapp.hk/via/atv/save-energy-forest/index.html#/rule?lang=tc&forceHideNavigationBar=true  并点击「活动规则」查看)。',
      '12.所有活动所获得的MyGarden减碳值、功能卡不可退换或兑换现金，亦不能更换丶退款丶转赠或转让他人，不同合资格参加者的MyGarden减碳值、功能卡亦不可合并使用。当合资格参加者撤销其MyLink注册账户时，其MyLink账户内的MyGarden减碳值、功能卡将会自动注销及不获补发，中移香港亦不会作出任何补偿。'
    ],
    // c10_1:[
    //   'MyGame游戏点券使用及注意事项',
    //   '13.合资格参加者如透过活动获得MyGame游戏点券，所获得的MyGame游戏点券会于领取当日起计7天内自动存入其MyLink账号。',
    //   '14.参加者可在MyLink「游戏乐园」页面点击右上角的「点券」，进入「我的点券」页面查询有关MyGame游戏点券的详情。',
    //   '15.合资格参加者领取及使用透过活动获得的MyGame游戏点券，须阅读并同意MyGame「游戏点券规则」页面内的条款及细则 (https://hk.playinjoy.com/packages/center/temp/index.html?thirdPartyToken=<<cmcchkhsh_thirdparty_token_channel=bU9JU0HAZG>>&lang=<<cmcchkhsh_cmplang>>#/view/recharge-center/recharge-center-guide )。',
    //   '16.活动所获得的MyGame游戏点券均不可退换或兑换现金，亦不能更换丶退款丶转赠或转让他人，不同合资格参加者的MyGame游戏点券亦不可合并使用。当合资格参加者撤销其MyLink注册账户时，其MyLink账户内的MyGame游戏点券将会自动注销，中移香港亦不会作出任何补偿。',
    // ],
    c11: '电子券使用及注意事项',
    c12: [
      '13.活动期内，合资格参加者如获得电子券，所获得的电子券会在3个工作天内自动存入其MyLink账户。',
      '14.合资格参加者兑换及使用电子券，须阅读并同意该电子券的条款及细则，电子券的条款及细则可在「个人头像–我的电子券」页面查阅。',
      '15.所有活动所获得的电子券均不可退换或兑换现金，亦不能更换丶退款丶转赠或转让他人，不同合资格参加者的电子券亦不可合并使用。当合资格参加者撤销其MyLink注册账户时，其MyLink账户内的电子券将会自动注销及不获补发，中移香港亦不会作出任何补偿。',
      '16.所有电子券在使用期限过后均属无效，任何逾期或未使用之电子券将不能退款、补发或更改为其他产品或服务。'
    ],
    c13: '个人资料注意事项',
    c14: [
      '17.合资格参加者同意中移香港之一般个人资料收集声明及私隐政策声明所载之内容，并接受其约束。上述声明分别载于 https://www.hk.chinamobile.com/tc/pics.html 及 https://www.hk.chinamobile.com/tc/privacy.html 。',
      '18.合资格参加者可能会被要求向中移香港提供个人识别资料。为让参加者可以参加活动，该些数据是必要的。倘若参加者未能提供所需资料，参加者将不能获得活动参加/获得奖品的资格。',
      '19.合资格参加者有权根据《个人资料（私隐）条例》(第 486 章)的规定，要求查阅或更正参加者之个人资料。如有任何查阅或更正资料的要求，详情请参阅中移香港的私隐政策声明。',
      '20.合资格参加者如欲查阅个人资料及更正个人资料或询问个人资料有关声明，请致函：中国移动香港有限公司，地址：香港新界葵涌葵昌路 51 号九龙贸易中心 1 座 20 楼，收信人：数据保护主任；或致电中国移动香港拒收商业电子讯息登记 热线 6226 4926 或客户服务热线 12580。'
    ],
    c15: '其他注意事项',
    c16: [
      '21.如发现合资格参加者以插件或其他非正式途径，如空号或假账户或其他影响公平性的方式参加活动， 中移香港将取消该参加者的参加活动资格而不作另行通知。',
      '22.如中移香港怀疑任何合资格参加者有（i）进行或与异常/可疑活动有关；或（ii）使用不当的方法或欺诈行为而使活动之任何部份运作中断或受到干扰，或导致技术问题；或发现（iii）任何不诚实的行为、提供虚假、错误或不正确的数据；或（iv）任何违反本条款及细则或其他任何适用法律或法例条文或任何监管规定；或（v）用户有任何非善意或恶意使用任何相关服务之情况；中移香港拥有酌情权及最终决定权在不作任何通知及毋须对任何人士负上任何责任的情况下，自行 决定暂停、取消其参加活动或获得奖品的资格及日后推广活动的资格，并对该用户保留追究权利。',
      '23.如任何人士曾经在中移香港的MyLink及网上商店的活动、或任何使用MyLink及网上商店的过程中作出不诚实及欺诈行为、或任何非善意或非正常之使用、或曾经违反中移香港任何活动之条款及细则之行为，将自动被列入活动黑名单，丧失参与活动及获得奖品的资格。',
      '24.所有是次活动所获赠的奖品受到相关条款及细则所限。',
      '25.中移香港对任何第三方供货商在活动中所提供的奖品或相关商品、服务之质量、安全性及合法性，第三方供货商的商誉与可信性均无控制力及保证。如对以上礼品或相关商品、服务的质素或供应情况有任何查询、申索或投诉，客户应直接向有关供货商提出。中移香港对此不承担任何责任。',
      '26.在法律容许之最大限度，中移香港不会对第三方在活动中供应之奖品的任何功能或内容、及使用奖品可能或实质所造成或引致的任何后果、费用、支出、损失或损害负上任何责任。',
      '27.中移香港并不会对任何第三方供货商在活动中所提供的奖品或相关商品、服务之任何相关数据、内容及其功能，包括但不限于特定目的之适用性、可用性、质量、性质、准确性和实用性、或当中可能包含之知识产权之正当性作出任何陈述、保证或承担任何责任。',
      '28.如因电力或网络故障、或其他中移香港不能控制的情况下任何服务失效、中断、延误或暂时中止所引致之损失及损害（不论直接或间接），例如因任何技术故障、困难或错误、网络故障、中断或挤塞、手机程序故障、任何第三方引致之原因、软件的不兼容性问题或其他任何原因（包括但不限于任何终端设备或互联网网络问题）而产生或引致任何迟延、遗失、错误或无法辨识的响应等情况、或未能参加活动或获得奖品，中移香港概不负责及不会作出任何补发或补偿。',
      '29.参加者参加活动及/或领取奖品纯属自愿性质及需自行承担参加活动及/或领取奖品之任何风险及全部责任。任何合资格参加者因参加活动及/或领取奖品而引致之任何损失、伤害、费用、索赔、诉讼（包括但不限于直接、间接及后果性损失），中移香港概不负上任何法律责任或作出赔偿。',
      '30.在法律容许之最大限度下，凡由于中移香港无法合理控制或并非其过失或疏忽所致的原因，包括天文台悬挂黑色暴雨、八号烈风或暴风信号或更高热带气旋警告信号、或香港政府公布的「极端情况」或自然灾害；或由香港政府或任何其他适用的国家法律机关所实施的限制，以致延迟或未能履行本条款及细则第2、4、6、7、9、11、13、及/或28条而造成任何损失或损害，中移香港均无须负责。',
      '31.本条款及细则及一切与本条款及细则相关的事项均应受香港法律专属管辖及以其作解释及执行。参加者同意，如有任何分歧、争议、请求、诉讼或索赔等，将不可撤回及无条件地服从香港法院的专属管辖权。  ',
      '32.本条款及细则中的每一条条款应有独立的执行力，其有效性不受其他条款之无效性影响。',
      '33.如任何参加者有任何违反法律、本条款及细则或可能损害第三方权利的行为或不作为，该参加者同意并契诺向中移香港为其行为或不作为引致或相关的任何纠纷及索赔作出全面弥偿以及使中移香港免受损害。',
      '34.除合资格参加者和中移香港外，任何人均不享有香港法例《合约(第三者权利)条例》(第623章)下的任何权利，以执行或享有本条款及细则任何条文的利益或权利。',
      '35.活动不设上诉机制。如有任何争议，中移香港保留最终决定权。任何争议将以中移香港之系统记录作为确据。',
      '36.本条款及细则的中、英文版如有任何歧义，概以中文版为准。',
      '37.推广生意的竞赛牌照号码：',
      '38.活动完结声明会在2026年2月6日于星岛日报及英文虎报刊登。'
    ]
  },
  d5: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon1_sc.png',
  d6: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon2_sc.png',
  d7: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon3_sc.png',
  d8: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon4_sc.png',
  d8_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/new11_list_icon5_sc.png',
  d9: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/jinbi.png',
  d10: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/ticket_over_sc.png',
  d11: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/tikect_normal.png',
  d12: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/top_title-img_sc.png',
  d13: '日历规则',
  d14: '本月积分签到累计',
  d15: '天',
  d16: '每月积分签到累计满14天可获',
  d17: '积分 (每月限领一次)',
  d18: '每日黄历',
  d19: '积分',
  d20: '卡券领取',
  d21: '已领取卡券',
  d22: '卡券抢光了!',
  d23: '是日无卡券',
  d24: '积分签到',
  d25: '已签到领分',
  d26: '你已签到领积分了',
  d27: '本月累计签到已满14天, 获得100积分',
  d28: '(每月限领一次)',
  d29: '签到成功',
  d30: '前往「积分攻略」',
  d31: '可以抢券啦, 手快有手慢无',
  d32: '来晚一步',
  d33: '抢光了!',
  d34: '抢券成功',
  d35: '前往「我的电子券」>',
  d36: '前往「积分明细」>',
  d37: '你已领券了',
  d38: '',
  d39: '可抢券, 手快有手慢无',
  d40: '来晚一步, 抢光了!',
  d41: '',
  d42: '可抢券, 记得来啊',
  d43: '你的手机或终端设备登入参加此活动的数量已超出限制',
  d44: '详情请参阅',
  d45: '《条款及细则》',
  d46: '知道了',
  d47: '剩余',
  d48: '份',
  d49: '提醒抢券说明',
  d50: '开启抢券提醒功能后，逢周一系统会发送提醒通知，关闭则不通知。',
  d51: '奖赏记录',
  d52: '日历奖赏',
  d53: '年',
  d54: '月',
  d55: '仅展示近6个月的记录',
  d56: '盲盒奖赏',
  d57: '完成',
  d58: '取消',
  d59: '选择年月',
  d60: '日',
  d61: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox12/smallClick_sc.webp',
  d62: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox/button_bottom_sc.png',
  d63: '每日签到赏你积分, 还会不定时发放电子优惠券, 先到先得! 快点去看看有什么优惠券可以抢啦!',
  d64: 'MyLink奖赏日历',
  d65: 'MyLink幸运盲盒',
  d66: '多谢参与',
  d67: '网络异常，请重试',
  d68: '抢券成功',
  d69: '无记录',
  d70: '周日',
  d71: '周一',
  d72: '周二',
  d73: '周三',
  d74: '周四',
  d75: '周五',
  d76: '周六',
  d77: '天',
  d78: '抢券反应热烈, 几分钟后再试吧',
  d79: '去领更多卡券',
  d79_1: '会员日日拎着数',
  d80: '去商城花积分',
  d81: '去使用',
  d81_1: '去参加',
  d82: '今天还有积分待领取喔',
  d83: '立即签到领积分',
  ruleDate: {
    c1: '「奖赏日历」之条款及细则（「本条款及细则」）',
    c1_1: '版本更新日期: 2026年3月12日',
    c2: [
      '1.「奖赏日历」（「活动」）由中国移动香港有限公司（「中移香港」）主办',
      '2.活动于香港时间2024年2月4日开始至2026年6月30日23:59结束（「活动期」），时间以中移香港的服务器时间为准。'
    ],
    c3: '合资格人士',
    c4: [
      '3.参加者需要符合以下资格方为活动的合资格参加者（「合资格参加者」）：',
      '(a)参加活动当日已年满18岁或以上的人士；',
      '(b)可成功注册并登入MyLink的人士，包括中移香港的现有储值卡客户、月费服务计划客户、家居宽带客户、企业客户（包括副卡和成员卡客户）及非中移香港用户；及；',
      '(c)非根据第24段被列入活动黑名单的人士。',
      '若未能符合上述资格，相关参加活动及/或获得MyLink 积分、电子券的资格将会被取消。'
    ],
    c5: '活动详情',
    c6: [
      '4.活动期内，合资格参加者可以以下方式参加活动：',
      '(a)「积分签到」活动：',
      'I.合资格参加者每个自然天在MyLink任务乐园页面点击「积分签到」按钮或于MyLink「极简版」之「每日积分签到活动」点击「立即签到」按钮，即可签到并获取2 MyLink积分一次，若该用户已付费办理「Link着数会员卡」或「着数会员（湾区版）」、且该会员卡仍在生效当中（「会员卡客户」），可额外获得3积分。而当每个自然月内累计签到满14天，该第14天的签到共可获得100 MyLink积分（「满14天100 MyLink积分」）。为免存疑，合资格参加者于获得满14天100 MyLink积分当天并不会获得每日签到的2 MyLink 积分，但会员卡客户的额外3积分则不受影响。',
      'II.合资格参加者每日最多可签到一次。除每个自然月内累计签到的第14日外，合资格参加者签到最多可获得2 MyLink积分一次，会员卡客户签到亦最多可获得相关额外3 MyLink积分一次。',
      'III.而满14天100 MyLink积分每个自然月最多可领取一次。',
      'IV.为免存疑，合资格参加者已成功累计签到满14天并获得满14天100 MyLink积分后，如客户在该自然月剩余日子每日签到仍可获得最多2 MyLink积分，会员卡客户签到则同时可继续获得相关额外3 MyLink积分。',
      'V.累计签到的次数于每个自然月最后一日下午23:59分清零并重新计算。',
      'VI.合资格参加者参与「积分签到」活动并领取积分，该合资格参加者则不可同一天同时参与MyLink「极简版」之「每日积分签到活动」领取积分，反之亦然。合资格参加者于「积分签到」活动及「极简版」之「每日积分签到活动」所累积的签到次数将一并计算。同时，参加者每月从「积分签到」活动及MyLink「极简版」之「每日积分签到活动」共可领取满14天100 MyLink积分最多一次。',
      'VII.即日起至2026年6月30日期间, 合资格参加者每天于奖赏日历完成积分签到后,出现最多一次「睇广告赚5积分!」的按钮。若因系统问题未出现「睇广告赚5积分!」的按钮，中移香港并不对此承担任何责任。 点击按钮即视为同意观看来自Google的时长为10秒至120秒的视频广告, 但非完成积分签到后就会必然出现视频广告, MyLink无法干预由Google分配的视频广告来源或频次。当有Google的视频广告出现, 合资格参加者于奖赏日历内完成该完整视频广告观赏后, 即待广告上的「指定秒数后可获奖励」按钮中的倒计时结束而且出现「已发放奖励」并关闭广告后, 奖赏日历主页出现「成功获得额外5积分」则可成功获得5积分奖励, 每位合资格参加者于一个历日内最多可获得该5积分一次。上述两个按钮的语言视乎合资格参加者使用中的设备之语言设置, 例如合资格参加者的设备语言使用的是英文, 按钮则会显示「Reward in 指定秒数 seconds」及「Reward granted」。如在观看视频广告过程中出现任何人为或不可抗力之情况导致无法完成该完整视频广告观赏, 包括但不限于合资格参加者退出MyLink、关机或出现网络异常等, 则无法获得上述奖励。合资格参加者不得使用任何技术手段或软件跳过广告。如发现合资格参加者作弊行为, MyLink有权取消其获得的积分奖赏, 而不做另行通知。观赏广告获额外5积分为独立积分获取活动并不受第（a）I-VI的规则限制。',
      'VIII.广告由第三方供货商Google提供, MyLink对Google提供的广告之内容的真实性、合法性及完整性均不负责, 对Google的商誉与可信度均无控制力及保证。如对广告有任何查询、申索或投诉, 合资格参加者应直接向有关供货商提出。MyLink对此不承担任何责任。',
      'IX.合资格参加者参加活动、观赏视频广告及/或获得额外积分纯属自愿性质及需自行承担参加活动、观赏视频广告及/或额外积分之任何风险及全部责任。有关MyLink之连结及第三方广告服务之相关条款及细则, 请参阅【关于MyLink】 > 【服务及条款】 中的第12段。',
      '(b)「卡券领取」活动：',
      'I.活动将会不定时发放不同种类、不同数量及限量的商户电子券（「电子券」）。',
      'II.合资格参加者可透过在MyLink任务乐园页面点击「卡券领取」按钮领取当日可获取并仍有领取余额的电子券。',
      'III.电子券不定时发放，每次发放的数量有限，先到先得，领完即止。',
      'IV.活动的「卡券领取」并非每天都有，合资格参与者可点击MyLink任务乐园页面内的活动日历查看当天及/或当月可领取的电子券详情、总共发放的数量、每位用户最多可获取的数量以及「卡券领取」具体的发放日期和时间。电子券种类及数量或会不时变动，发放的电子券详情以发放电子券当天实际页面显示为准。',
      'V.合资格参加者每日最多可点击领取当日派发的电子券一次，不得重复领取。',
      'VI.即日起至2026年6月30日期间，合资格参加者每天于奖赏日历完成卡券领取后，出现最多一次「睇广告获$5优惠券!」的按钮, 若因系统问题未出现「睇广告获$5优惠券!」的按钮，中移香港并不对此承担任何责任。「$」该符号在本条款与细则中意指港元。点击按钮即视为同意观看来自Google的时长为10秒至120秒的视频广告, 但非完成卡券领取后就会必然出现视频广告, MyLink无法干预由Google分配的视频广告来源或频次。当有Google的视频广告出现, 合资格参加者于奖赏日历内完成该完整视频广告观赏后, 即待视频广告上的「指定秒数后可获奖励」按钮中的倒计时结束而且出现「已发放奖励」并关闭视频广告后, 奖赏日历主页出现「成功获得额外卡券」则可成功获得1张指定「$5优惠券」奖励, 例如电子券满$120减$5优惠券（若卡券库存不足将在14个工作日内补发）, 每位合资格参加者于一个历日内最多可获得该优惠券1张。上述两个按钮的语言视乎合资格参加者使用中的设备之语言设置, 例如合资格参加者的设备语言使用的是英文, 按钮则会显示「Reward in 指定秒数 seconds」及「Reward granted」。如在观看视频广告过程中出现任何人为或不可抗力之情况导致无法完成该完整视频广告观赏, 包括但不限于合资格参加者退出MyLink、关机或出现网络异常等, 则无法获得上述奖励。合资格参加者不得使用任何技术手段或软件跳过广告。如发现合资格参加者作弊行为, MyLink有权取消其获得的卡券奖赏, 而不做另行通知。观赏广告可获1张【$5优惠券】为独立电子券获取活动并不受第（b）I-VI的规则限制。',
      'VII.广告由第三方供货商Google提供, MyLink对Google提供的广告之内容的真实性, 合法性及完整性均不负责, 对Google的商誉与可信度均无控制力及保证。如对广告有任何查询、申索或投诉, 合资格参加者应直接向有关供货商提出。MyLink对此不承担任何责任。',
      'VIII.合资格参加者参加活动、观赏视频广告及/或获得优惠卡券纯属自愿性质及需自行承担参加活动、观赏视频广告及/或优惠卡券之任何风险及全部责任。有关MyLink之连结及第三方广告服务之相关条款及细则, 请参阅【关于MyLink】 > 【服务及条款】 中的第12段。',
      'IX.指定「$5优惠券」的电子券详情或会不时变动，发放的电子券详情以发放电子券当天实际页面显示为准。此电子券的使用受相关的使用条款及细则约束, 合资格参加者可于「个人头像–我的电子券」页面查阅所获得的电子券及使用条款及细则。',
      '(c)「任务乐园看广告获积分」活动：',
      'I.即日起至2026年6月30日期间，合资格参加者每个历日在MyLink任务乐园页面点击「睇广告赚5积分」的按钮。若因系统问题未出现「睇广告赚5积分」的按钮，中移香港并不对此承担任何责任。点击按钮即视为同意观看来自Google的时长为10秒至120秒的视频广告, 但非必然出现广告, MyLink无法干预由Google分配的广告来源或频次。当有Google的视频广告出现, 合资格参加者于任务乐园内完成该完整视频广告观赏后, 即待广告上的「指定秒数后可获奖励」按钮中的倒计时结束而且出现「已发放奖励」并关闭广告后, 任务乐园主页出现「成功获得5积分」则可成功获得5积分奖励。每位合资格参加者于一个历日内透过「任务乐园看广告获积分」活动最多可获得该5积分两次。上述两个按钮的语言视乎合资格参加者使用中的设备之语言设置, 例如合资格参加者的设备语言使用的是英文, 按钮则会显示「Reward in 指定秒数 seconds」及「Reward granted」。如在观看视频广告过程中出现任何人为或不可抗力之情况导致无法完成该完整视频广告观赏, 包括但不限于合资格参加者退出MyLink、关机或出现网络异常等, 则无法获得上述奖励。合资格参加者不得使用任何技术手段或软件跳过广告。如发现合资格参加者作弊行为, MyLink有权取消其获得的积分奖赏, 而不做另行通知。「任务乐园看广告获积分」活动为独立积分获取活动并不受「积分签到」活动中观看广告赚取积分的规则限制。',
      'II.广告由第三方供货商Google提供, MyLink对Google提供的广告之内容的真实性, 合法性及完整性均不负责, 对Google的商誉与可信度均无控制力及保证。如对广告有任何查询、申索或投诉, 合资格参加者应直接向有关供货商提出。MyLink对此不承担任何责任。',
      'III.合资格参加者参加活动、观赏视频广告及/或获得积分奖励纯属自愿性质及需自行承担参加活动、观赏视频广告及/或额外积分之任何风险及全部责任。有关MyLink之连结及第三方广告服务之相关条款及细则, 请参阅【关于MyLink】 > 【服务及条款】 中的第12段。合资格参加者可点击任务乐园页面内的「积分明细」查看已领取的积分。',
      '(d)合资格参加者只可于每天00:00至23:59签到领取当天的电子券/MyLink 积分，不可补签/补领或提前签到/领取。',
      '5.每个终端设备（如手机、平板计算机）只限一位合资格参加者使用同5个香港流动电话号码登记的MyLink账号参加活动，如合资格参加者以同一个终端设备登入多于5个以上的MyLink账号参加活动，中移香港有权取消相关MyLink账号参加活动以及获得MyLink积分的资格。'
    ],
    c7: 'MyLink积分使用及注意事项',
    c8: [
      '6.活动期内，合资格参加者如获得MyLink积分，所获得的MyLink积分会在3个工作天内自动存入其MyLink账户。MyLink积分余额显示在「个人头像–我的积分」页面。',
      '7.活动所获得的MyLink积分有效期取决于积分被存入用户的 MyLink 帐户之时间（「积分有效期」）。',
      '8.如活动领取的MyLink积分与任何其他积分领取活动的条款细则存有差异，一律以MyLink帐户中所显示的有效MyLink积分为准。',
      '9.合资格参加者应于积分有效期满前使用MyLink积分作兑换奖赏或购买指定产品/服务，逾期作废，并将不获补发或延长有效期。合资格参加者兑换及使用积分，须阅读并同意MyLink积分计划的条款及细则（https://mylink.komect.com/mylink/#/integral/rules?lang=tc）。',
      '10.中移香港保留全部的酌情权及决定权处理用户的MyLink积分。在下列情况下， MyLink 可暂停发放MyLink积分或随时从任何用户的 MyLink 帐户中扣除MyLink积分而不作另行通知 (包括但不限于)：（a）在使用者欺诈或涉嫌欺诈的情况下；（b）用户以不公平的手段（包括但不限于不诚实使用、欺骗、错用或滥用）而获得MyLink积分；（c）用户取消、撤销任何符合领取MyLink积分的合资格服务或流动电话号码服务；（d）中移香港或任何服务提供商错误计算使用者应获取的MyLink积分；及／或（e）任何中移香港合理地确保使用者正当地积分的情况下。'
    ],
    c9: '电子券使用及注意事项',
    c10: [
      '11.活动内，合资格参加者如获得电子券，所获得的电子券会在3个工作天内自动存入其MyLink账户。合资格参加者可于「个人头像–我的电子券」页面查阅所获得的电子券。',
      '12.合资格参加者兑换及使用电子券即表示知悉并同意该电子券的条款及细则，电子券的条款及细则可在「我的电子券」页面查阅。',
      '13.合资格参加者获取电子券后，不可退换或兑换现金，亦不能更换丶退款丶转赠或转让他人，不同合资格参加者的电子券亦不可合并使用。当合资格参加者撤销其MyLink注册账户时，其MyLink帐户内的电子券将会自动注销及不获补发，中移香港亦不会作出任何补偿。',
      '14.所有电子券均有使用有效期（「电子券有效期」），以「我的电子券」页面上显示为准。所有电子券在电子券有效期过后均属无效，任何逾期或未使用之电子券将不能退款、补发或更改为其他产品或服务。',
      '15.中移香港保留全部的酌情权及决定权处理用户的电子券。在下列情况下， MyLink 可暂停发放电子券或随时从任何用户的 MyLink 帐户中扣除电子券而不作另行通知 (包括但不限于)：（a）在使用者欺诈或涉嫌欺诈的情况下； （b）用户以不公平的手段（包括但不限于不诚实使用、欺骗、错用或滥用）而获得电子券；（c）使用者取消、撤销任何符合领取电子券的合资格服务或流动电话号码服务；（d）中移香港或任何服务提供商错误计算用户应获取的电子券；及／或（e）任何中移香港合理地确保用户正当地使用电子券的情况下。',
    ],
    c11: '个人资料注意事项',
    c12: [
      '16.合资格参加者同意中移香港之一般个人资料收集声明及私隐政策声明所载之内容，并接受其约束。上述声明分别载于 https://www.hk.chinamobile.com/tc/pics.html及 https://www.hk.chinamobile.com/tc/privacy.html。',
      '17.合资格参加者可能会被要求向中移香港提供个人识别资料。为让参加者可以参加活动，该些数据是必要的。倘若参加者未能提供所需资料，参加者将不能获得活动参加/获得MyLink积分/电子券的资格。',
      '18.合资格参加者有权根据《个人资料（私隐）条例》(第 486 章)的规定，要求查阅或更正参加者之个人资料。如有任何查阅或更正资料的要求，详情请参阅中移香港的私隐政策声明。',
      '19.合资格参加者如欲查阅个人资料及更正个人资料或询问个人资料有关声明，请致函：中国移动香港有限公司，地址：香港新界葵涌葵昌路 51 号九龙贸易中心1座20楼，收信人：数据保护主任；或致电中国移动香港拒收商业电子讯息登记热线 6226 4926 或客户服务热线 12580。'
    ],
    c13: '其他注意事项',
    c14: [
      '20.如发现合资格参加者以插件或其他非正式途径，如空号或假账户或其他影响公平性的方式参加活动，中移香港将取消该参加者的参加活动及/或获得MyLink积分/电子券的资格而不作另行通知。',
      '21.如合资格参加者因任何中移香港未能控制之因素以致所递交之个人资料有错漏、不实或不正确，或导致中移香港未能联络或核实合资格参加者身份，即视为放弃参加活动及/或获得MyLink积分/电子券资格。合资格参加者不得要求补发或任何形式的补偿，中移香港亦毋须为此承担任何责任。',
      '22.如中移香港怀疑任何合资格参加者有（i）进行或与异常/可疑活动有关；或（ii）使用不当的方法或欺诈行为而使活动之任何部份运作中断或受到干扰，或导致技术问题；或发现（iii）任何不诚实的行为、提供虚假、错误或不正确的数据；或（iv）任何违反本条款及细则或其他任何适用法律或法例条文或任何监管规定；或（v）用户有任何非善意或恶意使用任何相关服务之情况；中移香港拥有酌情权及最终决定权在不作任何通知及毋须对任何人士负上任何责任的情况下，自行决定暂停、取消其参加活动及/或获得积分/电子券的资格及日后推广活动的资格，并对该用户保留追究权利。',
      '23.合资格参加者获取积分后，不可退换或兑换现金，亦不能更换丶退款丶转赠或转让他人，不同合资格参加者的积分亦不可合并使用。当合资格参加者撤销其MyLink注册账户时，其MyLink账户内的积分将会自动注销及不获补发，中移香港亦不会作出任何补偿。',
      '24.如任何人士曾经在中移香港的MyLink及网上商店的活动、或任何使用MyLink及网上商店的过程中作出不诚实及欺诈行为、或任何非善意或非正常之使用、或曾经违反中移香港任何活动之条款及细则之行为，将自动被列入活动黑名单，丧失参与活动及获得MyLink积分/电子券的资格。',
      '25.所有是次活动所获赠、购买和兑换的电子券、商品或服务受相关条款及细则约束。活动所有的电子券、商品或服务视乎供应情况而定，换领或售完即止。',
      '26.电子券由相关供货商（「供货商」）提供，中移香港对任何第三方供货商所提供的电子券或相关商品、服务之质量、安全性及合法性，供货商的商誉与可信性均无控制力及保证。如对以上电子券、商品或服务的质素或供应情况有任何查询、申索或投诉，客户应直接向有关供货商提出。中移香港对此不承担任何责任。',
      '27.在法律容许之最大限度，中移香港不会对第三方供应之电子券、商品或服务的任何功能或内容、及使用优惠可能或实质所造成或引致的任何后果、费用、支出、损失或损害负上任何责任。',
      '28.中移香港并不会对电子券、商品或服务之任何相关数据、内容及其功能，包括但不限于特定目的之适用性、可用性、质量、性质、准确性和实用性、或当中可能包含之知识产权之正当性作出任何陈述、保证或承担任何责任。',
      '29.如因电力或网络故障、或其他中移香港不能控制的情况下任何服务失效、中断、延误或暂时中止所引致之损失及损害（不论直接或间接），例如因任何技术故障、困难或错误、网络故障、中断或挤塞、手机程序故障、任何第三方引致之原因、软件的不兼容性问题或其他任何原因（包括但不限于任何终端设备或互联网网络问题）而产生或引致任何迟延、遗失、错误或无法辨识的响应等情况、或未能参加活动或获得积分/电子券，中移香港概不负责及不会作出任何补发或补偿。',
      '30.参加者参加活动及/或领取积分/电子券纯属自愿性质及需自行承担参加活动及/或领取积分/电子券之任何风险及全部责任。任何合资格参加者因参加活动及/或领取积分/电子券而引致之任何损失、伤害、费用、索赔、诉讼（包括但不限于直接、间接及后果性损失），中移香港概不负上任何法律责任或作出赔偿。',
      '31.凡由于中移香港无法合理控制或并非其过失或疏忽所致的原因，包括但不限于电力故障、战争、面臨战争威胁、骚亂或其他公民抗命行为、暴动、天灾、由政府或任何其他国家法律机关所实施的限制或任何其他工业或行业纠纷、火灾、爆炸、风暴、水灾、雷电、地震或其他自然灾害，以致延迟或未能履行本条款及细则的全部或部分条款而造成任何损失或损害，中移香港均无须负责。',
      '32.本条款及细则及一切与本条款及细则相关的事项均应受香港法律专属管辖及以其作解释及执行。参加者同意，如有任何分歧、争议、请求、诉讼或索赔等，将不可撤回及无条件地服从香港法院的专属管辖权。',
      '33.中移香港保留随时更改或终止活动及修订本条款及细则及相关条款及细则的权利而毋须事先通知。',
      '34.如任何参加者有任何违反法律、本条款及细则或可能损害第三方权利的行为或不作为，该参加者同意并契诺向中移香港为其行为或不作为引致或相关的任何纠纷及索赔作出全面弥偿以及使中移香港免受损害。',
      '35.本条款及细则中的每一条条款应有独立的执行力，其有效性不受其他条款之无效性影响。',
      '36.除合资格参加者和中移香港外，任何人均不享有香港法例《合约(第三者权利)条例》(第623章)下的任何权利，以执行或享有本条款及细则任何条文的利益或权利。',
      '37.活动不设上诉机制。如有任何争议，中移香港保留最终决定权。任何争议将以中移香港之系统记录作为确据。',
      '38.本条款及细则的中、英文版如有任何歧义，概以中文版为准。'
    ]
  },
  d84: '是日无卡券',
  d85: '点我看有什么优惠',
  d86: '多谢参与',
  d87: '忌',
  d88: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox12/titleBg_sc.webp',
  d89: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox2025/google_points_sc.webp',
  d90: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox2025/google_coupon_sc.webp',
  d91: '成功获得额外积分',
  d92: '成功获得额外卡券',
  d93: '网络异常',
  d94: '卡券发放失败',
  d95: '请待14个工作日内补发',
  d96: '你的手机或设备可获得此积分奖赏的数量已超出限制',
  d97: '您的手机/设备系统暂不支持Google广告展示',
  d98: '"您的手机/设备系统暂不支持此Google广告展示,请更新系统至最新版本"',
  d99: '展开',
  d100: '收起',
  d101: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox2025/points_banner_sc.webp',
  d101_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/googleBanner/points_banner_sc_new.webp',
  d102: 'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox2025/coupon_banner_sc.webp',
  d102_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/googleBanner/coupon_banner_sc_new.webp',
  d103:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox12/titleBgBlue_sc.webp',
  e1: '之前已领过这张卡券, 领取次数已达上限',
  e2: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/banner_sc.png',
  e2_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/vip_contract/banner_sc.png',
  e3: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/points_sc%402x.png',
  e3_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/vip_contract/points_sc.png',
  e4: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/tag_sc%402x.png',
  e4_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/vip_contract/tag_sc.png',
  e5: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/coupon_sc%402x.png',
  e6: '前往办理',
  e7: 'https://mylink.oss-accelerate.aliyuncs.com/vip_contract/coupon1_sc.png',
  e7_1:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/vip_contract/coupon1_sc.png',
  e8:'开通后，额外领',
  e9:'+90积分/月',
  e10:'会员专享券',
  e11:'每月还有',
  e11_1:'$1000+',
  e11_2:'省钱优惠等你拿！',
  e12:'暂不开通',
  e13:'立即开通',
  e14:'每月签到',
  e15:'积分,',
  e16:'还有',
  e17:'省钱优惠!',
  e18:'开通Link著数会员',
  g1:'暂无Google广告来源，请稍后再来~',
  g2:'您当前的设备不支持Google广告播放',
  g3:'您当前设备或MyLink App版本过低，不支持Google广告播放',
  g4:'拿额外卡券',
  g5:'拿额外积分',
  g6:'注意！还有积分未取哦！',
  g7:'注意！还有卡券未拿哦！',
  g8:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/btnMoreTicket_sc.png',
  g9:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox11/btnMorePoints_sc.png',
  removeDialogImg:'https://cdn.mylink.hk.chinamobile.com/komect/static/blindbox/newBox12/removeDialog_sc.webp',
  removeDialogText:'知道了',
}
